export const SOFTLINE_API_KUNDENINFO_LEISTE = 'fibu/kontenabfrage/v1/kontoinfo/{{idktostamm}}';
